import { render, staticRenderFns } from "./LanguageBanner.vue?vue&type=template&id=724fa2fe&"
import script from "./LanguageBanner.js?vue&type=script&lang=js&"
export * from "./LanguageBanner.js?vue&type=script&lang=js&"
import style0 from "./LanguageBanner.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports